import React from 'react';
import PropTypes from 'prop-types';
import './ContentLoader.scss';

const ContentLoader = ({
  isLarge,
}) => (
  <div className={`loader ${isLarge ? 'large' : ''}`} />
);

ContentLoader.propTypes = {
  isLarge: PropTypes.bool,
};

ContentLoader.defaultProps = {
  isLarge: false,
};

export default ContentLoader;
